export const container = 'bg-loader';
